export default __webpack_public_path__ + "static/media/940.4b6fc0d4.png";